import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

export function FDInputRow({ children, spacing }) {
  const theme = useTheme();
  return (
    <Box
      display="grid"
      // This 200px comes from FD's theme.ts' INPUT_MIN_WIDTH.
      // When we figure out the right interface and move this to FD, we should use that variable
      gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))"
      gridGap={theme.spacing(spacing)}
    >
      {children}
    </Box>
  );
}

FDInputRow.defaultProps = {
  spacing: 2,
};

FDInputRow.propTypes = {
  children: PropTypes.node.isRequired,
  spacing: PropTypes.number,
};
